
import * as React from "react";
import { Separator } from "@/components/ui/separator";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ThemeToggle } from "@/components/theme-toggle";
import { UserMenu } from "@/components/user-menu";
import { NotificationIcon } from "@/features/notifications/components/NotificationIcon";
import { CommandPalette } from "@/components/CommandPalette";

interface DashboardHeaderProps {
  pageInfo: {
    parent: string | null;
    current: string;
  };
}

export function DashboardHeader({ pageInfo }: DashboardHeaderProps) {
  // Get the currently selected project from localStorage or use a default
  const selectedProject = localStorage.getItem('selectedProject') || 'Orange Website';

  return (
    <header>
      <div className="flex items-center justify-between px-4 flex h-12 md:h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 border-b border-border">
        <div className="flex items-center gap-2">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="#">
                  {selectedProject}
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{pageInfo.current}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <div className="flex items-center gap-3">
          <CommandPalette />
          <NotificationIcon />
          <ThemeToggle />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
